<template>
  <div class="container-fluid schedule-page">
    <!--    데이터 생성/추가 후 update 이벤트 추가 필요-->
    <child-course-form-dialog
      ref="childCourseFormDialog"
      :data="selectedChildCourseData"
      :tab="dialogTab"
      @update="onScheduleDataUpdate"
    />

    <booking-block-dialog
      :is-dialog-visible.sync="dialog.booking.isVisible"
      :data="selectedBlockingData"
    />

    <date-based-page-header
      v-model="curDate"
      :calendar-unit="calendarUnit"
    >
      <template slot="desktop-control-buttons">
        <el-button
          class="calendar icon-word-btn ic-plus"
          style="margin-right: 10px;"
          @click="openChildCourseDialogToAdd(new Date())"
        >
          수업 추가
        </el-button>

        <el-radio-group
          v-model="calendarUnit"
          class="schedule-header__radio-group"
        >
          <el-radio-button label="daily">
            일
          </el-radio-button>
          <el-radio-button label="weekly">
            주
          </el-radio-button>
          <el-radio-button label="monthly">
            월
          </el-radio-button>
        </el-radio-group>
      </template>
      <template slot="mobile-control-buttons">
        <el-button
          class="calendar mobile-word-btn"
          @click="handleClickToday"
        >
          오늘
        </el-button>
        <el-button
          class="calendar icon-btn ic-plus"
          style="margin-left: 5px;"
          @click="openChildCourseDialogToAdd(new Date())"
        />
      </template>
    </date-based-page-header>

    <div class="calendar-container">
      <ScheduleCalandarByDaily
        v-if="calendarUnit === 'daily'"
        :dates="rangeDatesInCalendar"
        :loading="isScheduleLoading"
        @select="openChildCourseDialogToModify"
        @clickTime="openChildCourseDialogToAdd"
        @clickBlocking="openBlockingDialog"
      />
      <ScheduleCalandarByWeekly
        v-if="calendarUnit === 'weekly'"
        :loading="isScheduleLoading"
        :dates="rangeDatesInCalendar"
        @select="openChildCourseDialogToModify"
        @clickTime="openChildCourseDialogToAdd"
        @clickBlocking="openBlockingDialog"
      />
      <ScheduleCalandarByMonthly
        v-if="calendarUnit === 'monthly'"
        :cur-date="curDate"
        :dates="rangeDatesInCalendar"
        :loading="isScheduleLoading"
        @clickDate="handleClickDateInMonth"
        @select="openChildCourseDialogToModify"
        @clickBlocking="openBlockingDialog"
      />
    </div>
  </div>
</template>

<script>
import dateFns from 'date-fns';
import ClassEditForm from './course-dialog/ChildCourseEditForm';
import FiflFooter from '@/components/FiflFooter';
import ScheduleCalandarByWeekly from './calendars/ScheduleCalandarByWeekly';
import ScheduleCalandarByDaily from './calendars/ScheduleCalandarByDaily';
import ScheduleCalandarByMonthly from './calendars/ScheduleCalandarByMonthly';
import ChildCourseFormDialog from './ChildCourseFormDialog';
import { computedGetters } from '@/utils/vuex-helper';
import BookingBlockDialog from './BookingBlockDialog';
import DateBasedPageHeader from '@/components/DateBasedPageHeader';
import {
  getDailyRangeDates,
  getWeeklyRangeDates,
  getMonthlyRangeDates
} from '@/utils/date-helper';
import _ from 'lodash';
import { fiflboxApi } from '@/utils/api';

const CALANDAR_UNIT = {
  DAILY: 'daily',
  WEEKLY: 'weekly',
  MONTHLY: 'monthly'
};

export default {
  name: 'Schedule',
  components: {
    DateBasedPageHeader,
    BookingBlockDialog,
    ChildCourseFormDialog,
    ScheduleCalandarByDaily,
    ScheduleCalandarByWeekly,
    ScheduleCalandarByMonthly,
    FiflFooter,
    ClassEditForm
  },
  data() {
    return {
      curDate: new Date(),
      calendarUnit: null,
      curDateRange: {
        start: new Date(2018, 9, 11, 9, 0),
        end: new Date(2018, 11, 11, 9, 0)
      },
      schedules: {},
      selectedBlockingData: {
        id: null
      },
      selectedChildCourseData: {
        id: null,
        start: null
      },
      dialog: {
        booking: {
          isVisible: false
        }
      },
      dialogTab: null,
      isScheduleLoading: false
    };
  },
  async created() {
    this.calendarUnit = this.$localStore.getValue('calendarUnit') || 'daily';
    try {
      await this.$store.dispatch('syncPublicParentCourses');
      this.$store.dispatch('syncVaildMembers');
      this.$store.dispatch('syncInstructors');
      await this.$store.dispatch('syncParentCourses', {});
    } catch (err) {
      console.log(err);
    }
  },
  async mounted() {
    let { childCourseId, dt, dialogTab } = this.$route.query;

    if (dt && childCourseId) {
      this.openExistChildCourseDialog(dt, childCourseId, dialogTab);
    }
  },
  computed: {
    ...computedGetters(['parentCourseCategories', 'isScheduleMenuVisible']),
    dateHeader() {
      if (this.calendarUnit === CALANDAR_UNIT.DAILY) {
        return dateFns.format(this.curDate, 'YYYY년 M월 D일');
      }

      return dateFns.format(this.curDate, 'YYYY년 M월');
    },
    rangeDatesInCalendar() {
      return this.getRangeDatesInCalendar(this.curDate, this.calendarUnit);
    }
  },
  watch: {
    curDate: {
      handler(value) {
        this.syncSchedules(value, this.calendarUnit);
      }
    },
    calendarUnit: {
      handler(value) {
        this.$localStore.setValue('calendarUnit', value);
        this.syncSchedules(this.curDate, value);
      }
    },
    isScheduleMenuVisible: {
      immediate: true,
      handler: function(isAccessAllowed) {
        if (!isAccessAllowed) {
          this.$router.push('/announce/access-block').catch(() => {});
        }
      }
    }
  },
  methods: {
    syncSchedules: _.debounce(async function(targetDate, calendarUnit) {
      this.isScheduleLoading = true;
      const rangeDates = await this.getRangeDatesInCalendar(
        targetDate,
        calendarUnit,
        true
      );
      await this.$store.dispatch('syncChildCourses', {
        start: rangeDates[0],
        end: _.last(rangeDates)
      });
      await this.$store.dispatch('syncBlockings', {
        start: rangeDates[0],
        end: _.last(rangeDates)
      });
      this.isScheduleLoading = false;
    }, 500),
    getRangeDatesInCalendar(
      targetDate,
      calendarUnit,
      isIncludePriorDay = false
    ) {
      if (calendarUnit === CALANDAR_UNIT.WEEKLY) {
        return getWeeklyRangeDates(targetDate, isIncludePriorDay);
      }

      if (calendarUnit === CALANDAR_UNIT.MONTHLY) {
        return getMonthlyRangeDates(targetDate, true);
      }

      return getDailyRangeDates(targetDate, isIncludePriorDay);
    },
    handleClickToday() {
      this.curDate = new Date();
    },
    async onScheduleDataUpdate() {
      this.syncSchedules(this.curDate, this.calendarUnit);
    },
    handleClickDateInMonth(date) {
      this.calendarUnit = CALANDAR_UNIT.DAILY;
      this.curDate = date;
    },
    async findChildCourse(dt, childCourseId) {
      const dateString = dateFns.format(dt, 'YYYY-MM-DD');
      const datetimeString = dateFns.format(dt, 'YYYY-MM-DD HH:mm');

      const { data } = await fiflboxApi.v2.getChildCourses({
        date_after: dateString,
        date_before: dateString,
        booking_count: true
      });

      const childCourses = data[dateString];

      if (!childCourses) {
        return null;
      }

      return childCourses.find(schedule => {
        return (
          dateFns.format(schedule.dt, 'YYYY-MM-DD HH:mm') === datetimeString &&
          schedule.id == childCourseId
        );
      });
    },
    openBlockingDialog(data) {
      this.selectedBlockingData = Object.assign({}, data);
      this.dialog.booking.isVisible = true;
    },
    openChildCourseDialogToAdd(dt) {
      if (
        this.$refs['childCourseFormDialog'] &&
        this.$refs['childCourseFormDialog'].openDialogToAdd
      ) {
        this.$refs['childCourseFormDialog'].openDialogToAdd(dt);
      } else {
        this.$message('새로고침 후 다시 시도해주세요.');
      }
    },
    openChildCourseDialogToModify(value) {
      if (
        this.$refs['childCourseFormDialog'] &&
        this.$refs['childCourseFormDialog'].openDialogToModify
      ) {
        this.$refs['childCourseFormDialog'].openDialogToModify(value);
      } else {
        this.$message('새로고침 후 다시 시도해주세요.');
      }
    },
    async openExistChildCourseDialog(dt, childCourseId, dialogTab) {
      this.curDate = new Date(dt);
      const childCourse = await this.findChildCourse(dt, childCourseId);

      if (!childCourse) {
        return;
      }
      if (
        this.$refs['childCourseFormDialog'] &&
        this.$refs['childCourseFormDialog'].openDialogToModify
      ) {
        this.$refs['childCourseFormDialog'].openDialogToModify(
          childCourse,
          dialogTab
        );
      } else {
        this.$message('새로고침 후 다시 시도해주세요.');
      }
    }
  }
};
</script>

<style lang="scss">
// .schedule-page {
// 	overflow-y: hidden !important;
// }

.schedule-header__radio-group {
  border-radius: 6px;
  box-shadow: 0 2px 4px 0 rgba(180, 180, 180, 0.5);

  label {
    margin: 0;
  }

  .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    color: #4a4a4a;
    background-color: #d3d3d3;
    box-shadow: none;
  }

  .el-radio-button {
    &:first-child {
      .el-radio-button__inner {
        border-radius: 6px 0 0 6px;
        /*border: 0;*/
      }
    }

    &:last-child {
      .el-radio-button__inner {
        border-radius: 0 6px 6px 0;
        border: 0;
      }
    }

    .el-radio-button__inner {
      border: 0;
      color: #9b9b9b;
      padding: 14px 27px;
      border-right: 1px solid #d8d8d8;
    }
  }
}

.calendar-container {
  height: calc(100vh - 232px);

  @media screen and (max-width: 768px) {
    height: 66vh;
  }
}

.v-modal {
  opacity: 0.27;
  background: #202020;
}
</style>
